/*
export function someMutation (state) {
}
*/


export function SET_LIVRO(state, obj) {
  state.livro = obj;
}
